export const CONFERENCE_URL_MAX_LENGTH = 2048;

// eslint-disable-next-line no-control-regex
const CONTROL_OR_ANGLE = /[\u0000-\u001F\u007F<>]/;

/**
 * The shared https-join-link predicate.
 *
 * `conferenceUrl` becomes a public `href` on the compass and an anchor on the
 * review desk, so this is deliberately stricter than `isSafeSourceList` in
 * `planReviewCommit.ts`: no scheme but `https:`, no userinfo, no control or
 * angle-bracket characters, and a bounded length. Only a value that passes
 * this check is ever rendered as a link or written to `meetings`.
 */
export const isAcceptableConferenceUrl = (value: unknown): value is string => {
  if (
    typeof value !== 'string' ||
    value.length === 0 ||
    value.length > CONFERENCE_URL_MAX_LENGTH
  ) {
    return false;
  }
  if (CONTROL_OR_ANGLE.test(value)) return false;

  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return false;
  }

  return (
    url.protocol === 'https:' &&
    url.username === '' &&
    url.password === '' &&
    url.hostname !== ''
  );
};
